import React from "react";
import "./_footer.scss";

const Footer = () => (
  <footer
    style={{
      background: "var(--bg)",
      borderTop: "var(--borderTop)",
      transition: "color 0.2s ease-out, background 0.2s ease-out"
    }}
    className="tau-chain-footer"
  >
    <div className="container footer-container">
      <div className="row m-0">
        <div className="col-lg-4 col-md-6">
          <ul className="footer-links">
            <li>
              <a href="#">API</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
            <li>
              <a href="#">Terms</a>
            </li>
            <li>
              <a href="#">Privacy</a>
            </li>
          </ul>
        </div>

        <div className="col-lg-4 col-md-6">
          <p className="footer-contact">
            Contact us on <a href="#">Twitter</a> of <a href="#">Discord</a>
          </p>
        </div>

        <div className="col-lg-4 col-md-12">
          <p className="footer-website-update">
            Website last updated: Nov 08, 2019
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
